// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ze38","tabsBox":"styles_tabsBox___J0Es","createButton":"styles_createButton__3YH4q"};